import type { SearchHit } from '@contracts';
import { CopyButton } from '../ui/misc';

/** The reported name stays the name. This is a visible identifier, never another device alias. */
export function DeviceIdentity({ device }: { device: Pick<SearchHit, 'id' | 'title' | 'sameNameCount'> }) {
  const shortId = device.id.slice(0, 8).toLowerCase();
  return <span className="block text-[12px] text-ink-3" onClick={e => e.stopPropagation()}
    onDoubleClick={e => e.stopPropagation()} onKeyDown={e => {
      // Copy-button activation must not activate its result row; global search/navigation keys still bubble.
      if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
    }}>
    <span className="inline-flex items-center gap-1" title={`Device ID: ${device.id}`}>
      <span>ID</span><span className="font-mono">{shortId}</span>
      <CopyButton value={shortId} label={`Copy device ID ${shortId}`} />
    </span>
    {(device.sameNameCount ?? 0) > 1 && <span className="block text-attention">
      {device.sameNameCount} devices named {device.title} in this customer
    </span>}
  </span>;
}
